import { useEffect } from "react";
import { Link, Route, Routes, useParams } from "react-router-dom";
import PixelEdumanLoader from "../../components/loading/PixelEdumanLoader";
import flyingEduman from '../../assets/images/eduman+eduwoman.svg';
import { React, useState } from "react";

import "../../assets/css/pages/Verify.css";
import VerifyShell from "./VerifyShell";
import VerifiyResetPassword from "./VerifiyResetPassword";
import VerifySubscription from "./VerifySubscription";

const Verify = ({}) => {
    const [loading, setLoading] = useState(true);
    const [pageValid, setPageValid] = useState(true);
    const [verifiedMessage, setVerifiedMessage] = useState(false);
    const [ignoreNormalFunction, setIgnoreNormalFunction] = useState(false);


    useEffect(() => {
        // determines https or http connection based on env mode: Prod vs Dev. Dev = localhost, Prod assumes a functioning SSL cert to enable a secure connection.
        
    }, []);
    
    return (
        <>
            <Routes>
                <Route path="/" element={<VerifyShell setLoading={setLoading} setPageValid={setPageValid} setMessage={setVerifiedMessage} />} />
                <Route path="/associate" element={<VerifyShell setLoading={setLoading} setPageValid={setPageValid} setMessage={setVerifiedMessage} endpoint="/associate" />} />
                <Route path="/lockAccount" element={<VerifyShell setLoading={setLoading} setPageValid={setPageValid} setMessage={setVerifiedMessage} endpoint="/lockAccount" />} />
                <Route path="/setPassword" element={<VerifiyResetPassword loading={loading} setLoading={setLoading} pageValid={pageValid} setPageValid={setPageValid} endpoint="/setPassword" setIgnore={setIgnoreNormalFunction} />} />
                {/* <Route path="/subscriptions" element={
                    <VerifySubscription 
                        loading={loading}
                        setLoading={setLoading} 
                        setPageValid={setPageValid} 
                        setMessage={setVerifiedMessage}
                        setIgnore={setIgnoreNormalFunction}
                        endpoint="/subscriptions"
                    />} /> */}
                <Route path="/subscriptions" element={
                    <VerifyShell
                        setLoading={setLoading} 
                        setPageValid={setPageValid} 
                        setMessage={setVerifiedMessage}
                        endpoint="/subscriptions"
                    />} />
            </Routes>
            {   !loading ?
                <>
                    {   !ignoreNormalFunction &&
                        <>
                            {   verifiedMessage &&
                                <>
                                    <div className="flex flexCenter">
                                        <div className="flex flexColumn flexCenter verify-container">
                                            <img alt="Eduhero Mascot Flying" className="verify-flyingEduman" src={flyingEduman} />
                                            <div className="verify-message-container textAlignCenter">
                                                {verifiedMessage}
                                                <br />
                                                <Link to={"../../../"} className="verify-return">Return To Login</Link>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {   (!verifiedMessage || !pageValid) &&
                                <>
                                    <div className="flex flexCenter">
                                        <div className="flex flexColumn flexCenter verify-container">
                                            <img alt="Eduhero Mascot Flying" className="verify-flyingEduman" src={flyingEduman} />
                                            <div className="verify-message-container textAlignCenter">
                                                We were unable to verify your link at this time. Please refresh in a few moments. This link will remain valid for a brief period of time or until you resubmit a verification request.
                                                <br />
                                                <Link to={"../../../"} className="verify-return">Return To Login</Link>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    }
                </>
                :
                <>
                    <PixelEdumanLoader isAbsolute={true} message={"Loading..."} />
                </>
            }
        </>
    );
};

export default Verify;